import Vuex from 'vuex';
import Vue from 'vue';
import menu from './modules/menu';
import PillBarFilter from './modules/PillBarFilter';

Vue.use(Vuex);

// All modules are registered here where we create our Store. Otherwise they won't be recognised.
export default new Vuex.Store({
    modules: {
        menu,
        PillBarFilter
    }
})